import React from "react";
import BaseModal from "../../components/BaseModal";
import { useTranslation } from "react-i18next";
import { MODAL_TYPES } from "../../utils/emitter";
import "./style.scss";
import BaseTextButton from "../../components/BaseTextButton";
import Game from "../../store/Game";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import useCurrentGame from "../../hooks/useCurrentGame";
import ROUTES from "../../utils/routes";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import useModalActions from "../../hooks/useModalActions";

export default function CompleteTestToSeeResults() {
  const { t } = useTranslation();
  const { getUserData } = useCurrentUserData();
  const { setGame } = useCurrentGame();
  const { navigateTo } = useCustomNavigate();
  const { closeModal } = useModalActions();

  const createNewGame = async () => {
    const userData = getUserData();
    await Game.createNewGame(userData.id, (game) => {
      setGame(game);
      navigateTo(ROUTES.PERSONAL_ACCOUNT_PAGE);
      closeModal(MODAL_TYPES.COMPLETE_TEST_TO_SEE_RESULTS);
    });
  };

  return (
    <BaseModal
      descriptionStyle="complete-test-to-see-results__desc"
      eventTypeModal={MODAL_TYPES.COMPLETE_TEST_TO_SEE_RESULTS}
      description={t("modals.complete_test_to_see_results.text")}
    >
      <BaseTextButton
        className="complete-test-to-see-results__button"
        icon="plus"
        onClick={createNewGame}
      >
        {t("personal_acc.go_test")}
      </BaseTextButton>
    </BaseModal>
  );
}
